import { render, staticRenderFns } from "./GeneralRegistrationOfChanges.vue?vue&type=template&id=a63f47fc&scoped=true&"
import script from "./GeneralRegistrationOfChanges.vue?vue&type=script&lang=js&"
export * from "./GeneralRegistrationOfChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63f47fc",
  null
  
)

export default component.exports